import React, { useContext, useEffect } from 'react';

//Material UI
import { makeStyles } from '@material-ui/core';

//Contexts
import { store as reportStore } from '../reducer';

//Hooks
import useTitle from 'hooks/useTitle';
import Filters from './Filters';
import List from './List';
import Total from 'components/Total/Total';
import { useOnlineDriversStore } from 'useStores/useOnlineDriversStore';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
}));
const OnlineDrivers = () => {
  const classes = useStyles();
  useTitle('گزارش رانندگان آنلاین');

  const { dispatch: reportDispatch } = useContext(reportStore);
  const totalDrivers = useOnlineDriversStore((state) => state.totalDrivers);
  useEffect(() => {
    reportDispatch({
      type: 'CHANGE_TITLE_CATEGORY',
      payload: {
        title: '',
        category: '',
      },
    });
  }, []);

  return (
    <div className={classes.root}>
      <Filters />
      <List />
      <div className="w-25">
        <Total title="تعداد کل رانندگان" total={totalDrivers} endText={'نفر'} />
      </div>
      {/* <div className="d-flex" style={{ gap: 8, position: 'sticky', bottom: 0 }}>
        <Total
          backgroundColor={'purple'}
          total={toFA(formatNumber(toEN(rond(totalAmount))))}
        />
        <Total
          backgroundColor={'yellow'}
          title="جمع کل آنلاین: "
          total={toFA(formatNumber(toEN(rond(totalOnline))))}
        />
        <Total
          backgroundColor={'red'}
          title="جمع کل سنتی: "
          total={toFA(formatNumber(toEN(rond(totalOffline))))}
        />
      </div> */}
    </div>
  );
};

export default OnlineDrivers;
